import { render, staticRenderFns } from "./CaseCommonDialog.vue?vue&type=template&id=c0a1f114&scoped=true"
import script from "./CaseCommonDialog.vue?vue&type=script&lang=js"
export * from "./CaseCommonDialog.vue?vue&type=script&lang=js"
import style0 from "./CaseCommonDialog.vue?vue&type=style&index=0&id=c0a1f114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a1f114",
  null
  
)

export default component.exports